"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objekt_pfeil_sued = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
exports.objekt_pfeil_sued = leaflet_1.default.icon({
    iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC5SURBVFhH7ZZBCoMwFERDV116BI/aG/QIXbp06bJH6BG67DHsjGRAQhI0NIbKfzBIKPKem6oz/p079sSG5dQAymfsvZwKuPhrMyzAAizAAizAArYGdP66l6tfki0BD4yv3b0RFI9+2YgcN4zve+6FhRGp7wEKJ0z38iGKoJDiVEQsIJTztx4rJhcRBvxcLlIR64BqchGL0PmDVZWLMCK2anKRi6guF7GIw+RiHXG4XDCC/3RN5GfAuS9oPVGeZaedDgAAAABJRU5ErkJggg==",
    iconSize: [32, 32],
});
